import { AdsClickIcon, CodeIcon } from 'tuui';
import { FORM_MODES } from 'config/formModes';
import { FORM_MODE_TO_PATH_MAP } from 'config/routes';
import { TRACKING_ROUTE } from 'modules/tracking/config';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import { CONVERSION_ROUTE } from 'modules/tracking/config/routes/conversion';

export const EVENT_ICONS = {
    [CONVERSION_TYPE.EVENT_BASED]: AdsClickIcon,
    [CONVERSION_TYPE.BASIC]: CodeIcon,
};

export const CONVERSION_CREATION_PATH = `${TRACKING_ROUTE}${CONVERSION_ROUTE}/${
    FORM_MODE_TO_PATH_MAP[FORM_MODES.CREATE]
}`;

export const PAGE_VIEW_EVENT_NAME = 'page_view';

export const TYPE_INDICATORS = {
    OK: 'OK',
    ERROR: 'ERROR',
    ALERT: 'ALERT',
};

export const INTEGRATION_TYPE = {
    PIT_S2S: 'PIT_S2S',
    CLICKBANK: 'CLICKBANK',
    SHOPIFY_APP: 'SHOPIFY_APP',
};

export const S2S_INTEGRATION_TYPES = [INTEGRATION_TYPE.PIT_S2S, INTEGRATION_TYPE.CLICKBANK];
